import RegisterCustomerStep6 from "components/pages/application/register/RegisterCustomerStep6";

export default function CustomerupPackageFlowStep3() {
    return (
        <RegisterCustomerStep6 />
    );
}